
import { create } from 'zustand';

const useModelStore = create((set) => ({
  selectedModels: {}, // { [chatId]: modelId }

  setSelectedModel: (chatId, modelId) =>
    set((state) => ({
      selectedModels: { ...state.selectedModels, [chatId]: modelId },
    })),

  getSelectedModel: (chatId) => {
    const state = useModelStore.getState();
    return state.selectedModels[chatId] || null;
  },
}));

export default useModelStore;
